import React from 'react';
import { PersonalBankingSectionView } from './PersonalBankingSectionView';

export default function PersonalBankingSection() {

  const handleSignUp = () => {
    window.dispatchEvent(new CustomEvent('waya-open-download-popup'));
  };

  return (
    <PersonalBankingSectionView onSignUp={handleSignUp} />
  );
}

